import getEnvFromHostname from './getEnvFromHostname';

export enum ResultsVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
}

export const getEnvUrlPrefix = (version: ResultsVersion = ResultsVersion.V1): string =>
  'local' === getEnvFromHostname()
    ? `https://results.local.ue1dev1.rostrr.net:${ResultsVersion.V1 === version ? '5700' : '5600'}`
    : '';

export default getEnvUrlPrefix;
